var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDownload = function SvgDownload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16.717 18.463",
    fill: "none",
    stroke: "#3d60d3"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2.5 -1.5)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M3,17v2.62a1.746,1.746,0,0,0,1.746,1.746H16.971a1.746,1.746,0,0,0,1.746-1.746V17",
    transform: "translate(0 -1.902)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M8,12l3.493,3.493L14.985,12",
    transform: "translate(-0.634 -1.268)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    y2: 12,
    transform: "translate(11 2)"
  }))));
};
export default SvgDownload;